<template>
  <table-elements class="house-elements-list" :rows="elements" :header="header" :border-color="'#fff'">
    <template v-slot:body="{col}">
      <div class="col-lg-6 col-12 text-secondary">
        <span v-html="col.elementName"></span>
      </div>
      <div class="text-secondary"
           :class="{'col-lg-2 col-sm-4 col-12': withButtons, 'col-lg-3 col-sm-6 col-12': !withButtons}">
        {{ col.value }}
      </div>
      <div class="text-secondary"
           :class="{'col-lg-2 col-sm-4 col-6': withButtons, 'col-lg-3 col-sm-6 col-12': !withButtons}">
        {{ col.unit }}
      </div>
      <div class="col-lg-2 col-sm-4 col-6 buttons" v-if="withButtons">
        <button class="btn" @click="openEditElementModal(col.id)">
          <span class="ic-edit"></span>
        </button>
        <button class="btn" @click="openDeleteElementModal(col.id)">
          <span class="ic-trash"></span>
        </button>
      </div>
    </template>
  </table-elements>
</template>

<script>
import TableElements from "@/components/common/Tableelements";

export default {
  name: "ElementsList",
  components: {TableElements},
  props: {
    elements: {
      type: Array
    },
    withButtons: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openEditElementModal(elementId) {
      this.$emit('edit', elementId)
    },

    openDeleteElementModal(elementId) {
      this.$emit('delete', elementId)
    }
  },
  mounted() {
    if (!this.withButtons) {
      this.header = [
        {name: 'Элемент системы', width: 6},
        {name: 'Кол-во', width: 3},
        {name: 'Ед. изм', width: 3},
      ]
    }
  },
  data() {
    return {
      header: [
        {name: 'Элемент системы', width: 6},
        {name: 'Кол-во', width: 2},
        {name: 'Ед. изм', width: 2},
        {name: '', width: 2},
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.house-elements-list {
  padding: 0 1rem;

  .buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;

    .btn {
      padding: 0;

      span {
        font-size: 1.2rem;
        margin-left: 3px;
      }
    }
  }

}
</style>
